import React from 'react'
import CSS from './index.module.css'
import BaseComponent from '@base/BaseComponent'
// import moreInfo from '@assets/icon/moreInfo.png'
// import moreInfoShaw from '@assets/icon/moreInfoShaw.png'
// import { _ } from '@iskytrip/sdk'

class ProductIntroduction extends BaseComponent {
	constructor(props) {
		super(props)
		this.state = {
			isFirst: true,
			isShowMore: false,
			infoMaxHeight: 'none',
		}
	}

	componentDidMount() {
		this.calculate()
		setTimeout(this.calculate.bind(this), 500)
	}

	componentDidUpdate(prevProps, prevState) {
		this.calculate()
		setTimeout(this.calculate.bind(this), 500)
	}

	calculate() {
		// console.log('-------', this.productInfo)
		// console.log('-------', this.productInfo.offsetHeight)
		if (this.productInfo && this.productInfo.offsetHeight > 500 && this.state.isFirst) {
			this.setState({
				isShowMore: true,
				infoMaxHeight: '10rem',
				isFirst: false,
			})
		}
	}

	moreInfoClick() {
		this.setState({
			isShowMore: false,
			infoMaxHeight: 'none',
		})
	}

	render() {
		let title = this.props.title || '产品介绍'
		let content = this.props.content || ''
		let sectionStyle = this.props.sectionStyle || {}
		let titleStyle = this.props.titleStyle || {}

		return (
			<div className={CSS.section} style={sectionStyle}>
				<p className={CSS.sectionTitle} style={titleStyle}>
					{title}
				</p>
				<div
					ref={(e) => (this.productInfo = e)}
					className={CSS.sectionContent}
					style={{ maxHeight: this.state.infoMaxHeight }}
					dangerouslySetInnerHTML={{ __html: content }}
				></div>
				{this.state.isShowMore ? (
					<div onClick={this.moreInfoClick.bind(this)} className={CSS.moreButton}>
						<img
							src='https://publicdev.oss-cn-beijing.aliyuncs.com/icon/common/moreInfoShaw.png'
							alt=''
						/>
						<p>展开更多</p>
					</div>
				) : null}
			</div>
		)
	}
}

// 产品介绍
export default ProductIntroduction
